import { useEffect, useState } from "react";

const ELIGIBILITY_MS = 60000;

export default function ExerciseFeedback({ apiUrl, slug, exerciseId, auditId }) {
  const [eligible, setEligible] = useState(false);
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [status, setStatus] = useState("idle");

  useEffect(() => {
    const timer = window.setTimeout(() => setEligible(true), ELIGIBILITY_MS);
    return () => window.clearTimeout(timer);
  }, []);

  const submit = async (event) => {
    event.preventDefault();
    if (!rating || status === "sending") return;
    setStatus("sending");
    try {
      const response = await fetch(`${apiUrl}/api/exercises/${slug}/feedback`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ rating, comment: comment.trim(), auditId }),
      });
      if (!response.ok) throw new Error("feedback failed");
      setStatus("sent");
    } catch {
      setStatus("error");
    }
  };

  if (!eligible) {
    return <p className="exercise-feedback-wait" data-testid="exercise-feedback-eligibility">Reflection opens after one minute with the material.</p>;
  }

  if (status === "sent") {
    return <p className="exercise-feedback-thanks" data-testid="exercise-feedback-confirmation">Thank you for sharing your reflection.</p>;
  }

  return (
    <form onSubmit={submit} className="exercise-feedback" data-testid="exercise-feedback-form">
      <p className="exercise-eyebrow">Reflect on this exercise</p>
      <div className="exercise-stars" aria-label="Rate this exercise" data-testid="exercise-feedback-rating">
        {[1, 2, 3, 4, 5].map((value) => (
          <button key={value} type="button" onClick={() => setRating(value)} aria-label={`${value} star${value > 1 ? "s" : ""}`} aria-pressed={rating === value} data-testid={`exercise-rating-${value}`}>
            {value <= rating ? "★" : "☆"}
          </button>
        ))}
      </div>
      <label htmlFor="exercise-comment">Comment <span>(optional)</span></label>
      <textarea id="exercise-comment" value={comment} onChange={(event) => setComment(event.target.value)} maxLength={2000} data-testid="exercise-feedback-comment" />
      {status === "error" && <p className="exercise-form-error" data-testid="exercise-feedback-error">Your reflection could not be saved. Please try again.</p>}
      <button type="submit" disabled={!rating || status === "sending"} data-testid="exercise-feedback-submit">Save reflection</button>
    </form>
  );
}